import { render, staticRenderFns } from "./WebcastSettings.vue?vue&type=template&id=4971070e&lang=en&"
import script from "./WebcastSettings.vue?vue&type=script&lang=js&"
export * from "./WebcastSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports